import { render, staticRenderFns } from "./Bid.vue?vue&type=template&id=037b2f69&scoped=true"
import script from "./Bid.vue?vue&type=script&lang=js"
export * from "./Bid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b2f69",
  null
  
)

export default component.exports